var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"carrousel"}},[_c('div',{class:'image' + (_vm.current + 1)},[_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.descriptions[_vm.current]))])]),_c('div',{class:'preload image' + (_vm.post + 1)})])}
var staticRenderFns = []

export { render, staticRenderFns }